/**
 * Hook Questions Admin API client.
 *
 * Auth + base-URL pattern matches morningBriefAdminApi.js / aiChatAnalyticsApi.js.
 */

function getChatBaseUrl() {
    const override = localStorage.getItem('chatBaseUrl');
    if (override) return override;
    const env = localStorage.getItem('env') === 'true';
    return env
        ? 'https://prod-chat-module-api.dugoutlive.com'
        : 'https://chat-module-api.dugoutlive.com';
}

function getAuthHeaders() {
    const token = sessionStorage.getItem('sessionToken');
    if (!token) return {};
    return { Authorization: `Bearer ${token}`, auth: token };
}

async function handleResponse(res) {
    if (!res.ok) {
        let errorMsg = `Request failed: ${res.status}`;
        try {
            const body = await res.json();
            errorMsg = body.message || body.error || errorMsg;
        } catch {}
        throw new Error(errorMsg);
    }
    return res.json();
}

export async function lookupMatch(matchId) {
    const res = await fetch(`${getChatBaseUrl()}/admin/hook-questions/match/${encodeURIComponent(matchId)}`, {
        credentials: 'include',
        headers: getAuthHeaders(),
    });
    return handleResponse(res);
}

export async function regenerateHookQuestions({ matchId, situation }) {
    const res = await fetch(`${getChatBaseUrl()}/admin/hook-questions/regenerate`, {
        method: 'POST',
        credentials: 'include',
        headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ match_id: matchId, situation }),
    });
    return handleResponse(res);
}
